export const ButtonHeaderCloseComponent = {
  bindings: {},
  templateUrl:
    'components/Buttons/button-header-close/button-header-close.html',
};
